<template>
  <div class="mt-8">
    <div class="intro-y flex flex-col sm:flex-row items-center">
      <PageHeader class="text-lg font-medium mr-auto" />
    </div>
    <div class="intro-y mt-5 overflow-auto lg:overflow-visible">
      <LoanTable
        :loading="isLoading"
        :rows="loanList"
        :columns="columns"
        :line-numbers="true"
        :sort="sort"
        :page="page"
        :per-page="perPage"
        :page-size="pageSize"
        :total-page="totalPage"
        :total-records="totalRecords"
        :lending-status="lendingStatus"
        :lending-id="lendingId"
        @delete="confirmRemoval"
        @onFilter="onFilter"
        @onPageChange="onPageChange"
        @onPerPageChange="onPerPageChange"
        @onSortChange="onSortChange"
        @lending="lending"
      />
    </div>

    <ConfirmDialog :modal-id="deleteModalId" @ok="onDelete" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { LOAN_LIST_REQUEST, LENDING_REQUEST } from '@/store/actions/loan';
import PageHeader from '@/components/ui/PageHeader';
import LoanTable from '@/components/loan/LoanTable';
import dataListMixin from '@/mixins/dataListMixin';
import Repository, { LOANS } from '@/repositories/RepositoryFactory';

const LoansRepository = Repository.get(LOANS);

export default {
  mixins: [dataListMixin],

  components: {
    PageHeader,
    LoanTable,
  },

  data() {
    return {
      storeActionListRequest: LOAN_LIST_REQUEST,
      columns: [
        {
          label: this.$t('text.loanNumber'),
          field: 'id',
          filterable: true,
        },
        {
          label: this.$t('text.firstName'),
          field: 'firstName',
          filterable: true,
          disabled: true,
        },
        {
          label: this.$t('text.customer'),
          field: 'user',
        },
        {
          label: this.$t('text.registrationNumber'),
          field: 'registrationNumber',
          filterable: true,
          disabled: true,
        },
        {
          label: this.$t('table.phone'),
          field: 'phone',
          filterable: true,
        },
        {
          label: this.$t('text.loanAmount'),
          field: 'amount',
        },
        {
          label: this.$t('text.status'),
          field: 'status',
        },
        {
          label: this.$t('text.numberOfBankAccount'),
          field: 'bankAccount',
          filterable: true,
        },
        {
          label: this.$t('text.loanOfficer'),
          field: 'officer',
        },
        {
          label: this.$t('text.loanDateRepaymentFull'),
          field: 'endDate',
          filterable: true,
        },
        {
          label: this.$t('table.action'),
          field: 'action',
        },
      ],
    };
  },

  computed: {
    ...mapGetters(['loanList', 'loanStatus', 'loanMeta', 'lendingStatus', 'lendingId']),
    isLoading() {
      return this.loanStatus === 'loading';
    },
  },

  created() {
    this.fetchData();
  },

  methods: {
    async lending(id) {
      await this.$store.dispatch(LENDING_REQUEST, id);
      if (this.lendingStatus === 'success') {
        this.fetchData();
        this.$toasted.show(this.$t('toast.success'), { type: 'success' });
      }
    },
    async onDelete() {
      cash(`#${this.deleteModalId}`).modal('hide');
      try {
        await LoansRepository.delete(this.itemIdToRemove);
        await this.fetchData();
        this.$toasted.show(this.$t('toast.success'), { type: 'success' });
      } catch (error) {
        this.$toasted.show(error.message, { type: 'error' });
      }
      this.itemIdToRemove = null;
    },
    setFilterValues(data) {
      data.filters[`filter[status]`] = 'PENDING';
    },
    setPaginationValues() {
      this.totalRecords = this.loanMeta ? this.loanMeta.total : 1;
      this.page = this.loanMeta.currentPage;
      this.totalPage = this.loanMeta.lastPage;
      this.footerAmount = this.loanMeta ? this.loanMeta.totalAmount : 0;
    },
  },
};
</script>
